<div class="card bg-emphasis bg-opacity-25"  [ngClass]="{'card-expand':fullScreen, 'bg-emphasis':!fullScreen}">
  <div class="card-body p-0 map-frame" [style.height.px]="widget.height">

    <div class="d-flex fw-bold small mb-2 p-2 m-3px text-truncate text-uppercase" *ngIf="widget.showTitle">
      <span class="flex-grow-1">{{widget.name}}</span>
      <a class="text-default text-opacity-75 text-decoration-none mr-2 clickable" (click)="refresh()" data-bs-original-title="" title=""><i class="bi bi-arrow-repeat"></i></a>
      <a class="text-default text-opacity-75 text-decoration-none ml-2 clickable" (click)="toggleFullscreen()" data-bs-original-title="" title=""><i class="bi bi-fullscreen"></i></a>
    </div>
    
    <div #mapContainer id="map" [style.width]="'100%'" [style.height]="fullScreen || widget.showTitle ? 'calc(100% - 36px)' : '100%'"></div>
    
  </div>
</div>